export default __webpack_public_path__ + "static/media/thought-catalog.3d36590b.webp";